<template>
  <div>
    <template v-for="(item, idx) in ui.buttons">
      <img @click="clickButton(item)" v-if="item.type === 1 && item.content" :src="item.content" :key="'buttons' + idx" :style="getItemStyle(item)">
      <div @click="clickButton(item)" v-if="item.type === 2" :key="'buttons' + idx" :style="getItemStyle(item)">
        {{ item.content }}
      </div>
    </template>
    <template v-for="(item, idx) in ui.elements">
      <img v-if="item.type === 1 && item.content" :src="item.content" :key="'elements-' + idx" :style="getItemStyle(item)">
      <div v-if="item.type === 2" :key="'elements-' + idx" :style="getItemStyle(item)">
        {{ item.content }}
      </div>
    </template>
    <ui-popup ref="popup" :ui="ui"></ui-popup>
  </div>
</template>
<script>
import { getSimulatorBodyStyle, getPageSizeStyle, getItemStyle } from '@/libs/tool'
import UiPopup from './popup.vue'
import { Loading } from 'vant'

export default {
  name: 'UiElement',
  components: {
    UiPopup,
    Loading
  },
  props: {
    projectId: {
      type: String
    },
    member: {
      type: Object
    },
    apiroot: {
      type: String
    },
    ui: {}
  },
  data () {
    return {
      luckLoading: false,
      luckList: []
    }
  },
  computed: {
  },
  watch: {
  },
  methods: {
    getSimulatorBodyStyle (background) {
      return getSimulatorBodyStyle(background)
    },
    getPageSizeStyle (obj) {
      return getPageSizeStyle(obj)
    },
    getItemStyle (obj, idx) {
      return getItemStyle(obj)
    },
    clickButton (item) {
      switch (item.button_type) {
        case 'open_box':
          this.$refs.popup.openMsg(item.button_obj.title, '<pre>' + item.button_obj.content + '</pre>')
          break
        default:
          console.log(item)
      }
    }
  },
  mounted () {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ui/element.vue